import { LlmArtifactService, LlmConversationNode } from '@adaptiva/ai/common';
import { inject, Pipe, PipeTransform } from '@angular/core';

@Pipe({
	name: 'adaLlmForkArtifactCount'
})
export class LlmForkArtifactCountPipe implements PipeTransform {

	protected readonly artifacts: LlmArtifactService = inject(LlmArtifactService);

	public transform(_fork: LlmConversationNode): int {
		const _artifactList: LlmConversationNode[] = this.artifacts.generateArtifactList(_fork);

		return _artifactList.length;
	}

}
